/*
 * Copyright (c) 2024, Hack This Fall Sri Lanka. (https://hackthisfall.tech/). All Rights Reserved.
 *
 * This software is the property of Hack This Fall Sri Lanka. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by Hack This Fall in accordance with
 * the Hack This Fall Commercial License available at https://hackthisfall.tech/coc.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with Hack This Fall governing the purchase of this software and any
 * associated services.
 */

import React from "react";
import "./index.css";
import SectionHeader from "../SectionHeader";

const DiscordSection = () => {
  return (
    <section className="base-section discord-section">
      <SectionHeader number={4} title="Wait, The Story Doesn’t \n End Here" subtitle="Get to know us better" highlightWord="End" />
    </section>
  );
};

export default DiscordSection;
